/**
 * 登录页入口
 * 加载在 login.html，只处理登录/注册逻辑
 */
import { showToast } from './ui-toast.js';
import { login, register } from './modules/auth.js';

// Toast 用于 auth 模块的反馈
window.showToast = showToast;

const DEMO_EMAIL = 'demo@example.com';
const DEMO_PASSWORD = 'demo123';

// 预置演示账号（仅在本地/非生产环境注入，避免生产暴露公开口令）
function seedDemoAccount() {
    const host = window.location.hostname || '';
    const isLocal = host === 'localhost' || host === '127.0.0.1' || host === '';
    if (!isLocal) return;
    const users = JSON.parse(localStorage.getItem('competitor_users') || '[]');
    if (!users.some(u => u.email === DEMO_EMAIL)) {
        // 演示账号密码也以哈希存储（与注册逻辑一致）
        sha256Local('competitor-sandbox::' + DEMO_PASSWORD).then(function(hash) {
            users.push({
                email: DEMO_EMAIL,
                password: hash,
                name: '演示用户',
                createdAt: Date.now()
            });
            localStorage.setItem('competitor_users', JSON.stringify(users));
            seedDemoData();
        });
    } else {
        // 兼容迁移：若演示账号仍是明文，升级为哈希
        const demo = users.find(u => u.email === DEMO_EMAIL);
        if (demo && demo.password === DEMO_PASSWORD) {
            sha256Local('competitor-sandbox::' + DEMO_PASSWORD).then(function(hash) {
                demo.password = hash;
                localStorage.setItem('competitor_users', JSON.stringify(users));
            });
        }
    }
}

function sha256Local(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str))
        .then(function(buf) {
            return Array.prototype.map.call(new Uint8Array(buf), function(b) {
                return ('0' + b.toString(16)).slice(-2);
            }).join('');
        });
}

function seedDemoData() {
    // 预置演示数据
    const demoKey = 'competitorTracker_' + DEMO_EMAIL.replace(/[^a-zA-Z0-9@._-]/g, '');
    if (!localStorage.getItem(demoKey)) {
        const today = new Date().toISOString().slice(0, 10);
        // 近 4 天 RevPAR 留痕（演示趋势图）
        const history = {};
        for (let i = 3; i >= 0; i--) {
            const d = new Date(Date.now() - i * 86400000).toISOString().slice(0, 10);
            history[d] = {
                occupancy: 72 - i * 3, efficiency: '1.25', utilization: 68 - i * 2,
                adr: 520, revpar: Math.round(((72 - i * 3) / 100) * 520 * 100) / 100,
                capturedAt: new Date(Date.now() - i * 86400000).toISOString()
            };
        }
        const demoData = {
            schemaVersion: 1,
            archives: {},
            currentArchive: null,
            currentTime: 'morning',
            selectedDate: today,
            selfHotel: {
                name: '山水国际酒店', area: '芙蓉区核心商圈', star: '四星级',
                rooms: '280', occupancy: '72', efficiency: '1.25',
                utilization: 68, adr: '520', coverNote: '', createdAt: new Date().toISOString(),
                roomTypes: {}, history: history
            }
        };
        localStorage.setItem(demoKey, JSON.stringify(demoData));
    }
}
seedDemoAccount();

// ==================== Login Page Helpers ====================

window.switchAuthTab = function(tab) {
    const loginForm = document.getElementById('loginForm');
    const registerForm = document.getElementById('registerForm');
    const loginTab = document.getElementById('loginTab');
    const registerTab = document.getElementById('registerTab');
    const indicator = document.getElementById('authTabIndicator');

    if (tab === 'login') {
        loginForm.style.display = '';
        registerForm.style.display = 'none';
        loginTab.classList.add('active');
        registerTab.classList.remove('active');
        if (indicator) indicator.style.transform = 'translateX(0)';
    } else {
        loginForm.style.display = 'none';
        registerForm.style.display = '';
        registerTab.classList.add('active');
        loginTab.classList.remove('active');
        if (indicator) indicator.style.transform = 'translateX(100%)';
    }
};

window.handleLogin = function() {
    const email = document.getElementById('loginEmail').value.trim();
    const password = document.getElementById('loginPassword').value;
    login(email, password);
};

window.handleRegister = function() {
    const name = document.getElementById('registerName').value.trim();
    const email = document.getElementById('registerEmail').value.trim();
    const password = document.getElementById('registerPassword').value;
    register(email, password, name);
};

window.quickLogin = function() {
    document.getElementById('loginEmail').value = DEMO_EMAIL;
    document.getElementById('loginPassword').value = DEMO_PASSWORD;
    login(DEMO_EMAIL, DEMO_PASSWORD);
    if (window.CLOUD_MODE) {
        // 云端演示：先尝试注册（首次），已存在则自动登录
        register(DEMO_EMAIL, DEMO_PASSWORD, '演示用户');
    }
};

// 回车键提交
document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
        const loginForm = document.getElementById('loginForm');
        if (loginForm.style.display !== 'none') {
            window.handleLogin();
        } else {
            window.handleRegister();
        }
    }
});
